/**
 * checks if environment is node or not
 *
 * @returns boolean
 */
export const isNode = () => typeof process !== "undefined"
